
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clinical-information",
      function () {
        return require("private-next-pages/clinical-information.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clinical-information"])
      });
    }
  